import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import "./ConfirmModal.css";

/**
 * In-app confirm dialog (replaces window.confirm).
 *
 * Props:
 * - isOpen, title, message, confirmLabel, cancelLabel
 * - confirmColor: "primary" | "danger" | "warning" | ...
 * - confirming: disable buttons + show spinner on confirm
 * - onConfirm, onCancel
 */
function ConfirmModal({
  isOpen,
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  confirming = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      isOpen={!!isOpen}
      toggle={confirming ? undefined : onCancel}
      centered
      className="qt-confirm-modal"
      backdrop={confirming ? "static" : true}
      keyboard={!confirming}
      zIndex={1060}
    >
      <ModalHeader toggle={confirming ? undefined : onCancel}>{title}</ModalHeader>
      <ModalBody>
        {typeof message === "string" ? <p className="qt-confirm-message mb-0">{message}</p> : message}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline disabled={confirming} onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button color={confirmColor} disabled={confirming} onClick={onConfirm}>
          {confirming ? <Spinner size="sm" /> : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;
